import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { LabelOverrides, applyLabelCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-label',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxLabelStyleDirective {
  componentStyle = input<{
    style: LabelOverrides
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyLabelCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
